"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Menu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Menu"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _classnames = _interopRequireDefault(require("classnames"));
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/events"));
var _types = require("./types");
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));
var _DisallowedPromotionModal = _interopRequireDefault(require("./DisallowedPromotionModal"));
var _events2 = require("./events");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var DropdownIcon = function DropdownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 4 0 0v7.5L4 4Z"
  }));
};
DropdownIcon.defaultProps = {
  viewBox: "0 0 4 8",
  xmlns: "http://www.w3.org/2000/svg"
};
var LifecycleStateIcon = function LifecycleStateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m13.22 0 1.177 1.684H6.183L2.056 7.578l4.127 5.894h8.214l-1.179 1.684H5.306L0 7.578 5.306 0h7.913Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m10.104 5.642-.842-.59v4.716l.842-.59L12.63 7.41"
  }));
};
LifecycleStateIcon.defaultProps = {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "popover-wrapper": "LifecycleState__popover-wrapper__1Ff8c",
  "popoverWrapper": "LifecycleState__popover-wrapper__1Ff8c",
  "container": "LifecycleState__container__3-Faz",
  "published": "LifecycleState__published__2-Z9Z",
  "published-edit": "LifecycleState__published-edit__rjH3d",
  "publishedEdit": "LifecycleState__published-edit__rjH3d",
  "development": "LifecycleState__development__2vPq_",
  "development-edit": "LifecycleState__development-edit__VWk6h",
  "developmentEdit": "LifecycleState__development-edit__VWk6h",
  "deprecated": "LifecycleState__deprecated__35P3a",
  "deprecated-edit": "LifecycleState__deprecated-edit__22zI4",
  "deprecatedEdit": "LifecycleState__deprecated-edit__22zI4",
  "lifecycle-state": "LifecycleState__lifecycle-state__2sdPy",
  "lifecycleState": "LifecycleState__lifecycle-state__2sdPy",
  "icon": "LifecycleState__icon__1sKrw",
  "dropdown-icon": "LifecycleState__dropdown-icon__2l1Yy",
  "dropdownIcon": "LifecycleState__dropdown-icon__2l1Yy",
  "menu-header": "LifecycleState__menu-header__3RQEW",
  "menuHeader": "LifecycleState__menu-header__3RQEW",
  "menu-title": "LifecycleState__menu-title__3Llp_",
  "menuTitle": "LifecycleState__menu-title__3Llp_",
  "menu-item-label": "LifecycleState__menu-item-label__2Bi-z",
  "menuItemLabel": "LifecycleState__menu-item-label__2Bi-z",
  "warning-icon": "LifecycleState__warning-icon__1JA0J",
  "warningIcon": "LifecycleState__warning-icon__1JA0J",
  "menu-icon": "LifecycleState__menu-icon__1no_1",
  "menuIcon": "LifecycleState__menu-icon__1no_1",
  "menu": "LifecycleState__menu__2nbH-",
  "menu-options": "LifecycleState__menu-options__3y1qG",
  "menuOptions": "LifecycleState__menu-options__3y1qG",
  "menu-item": "LifecycleState__menu-item__3jhwF",
  "menuItem": "LifecycleState__menu-item__3jhwF",
  "spinner": "LifecycleState__spinner__2VjIH",
  "loader": "LifecycleState__loader__2vter",
  "light-theme": "LifecycleState__light-theme__3IReQ",
  "lightTheme": "LifecycleState__light-theme__3IReQ"
}; 
require('./LifecycleState.css');
var tooltipContent = 'The lifecycle state of an asset shows its status in the software development lifecycle, from development to stable releases to deprecation.';
var LoadingLifecycleState = function LoadingLifecycleState() {
  return /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    "data-test-id": "lifecycle-state-loading",
    height: 28,
    width: 150,
    className: styles.loader
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: 150,
    height: 28
  }));
};
var LoadingLifecycleStateOptions = function LoadingLifecycleStateOptions(_ref) {
  var canAdmin = _ref.canAdmin;
  return /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    "data-test-id": "lifecycle-state-options-loading",
    height: canAdmin ? 117 : 77,
    width: 205
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 12,
    y: 10,
    rx: 3,
    ry: 3,
    width: 112,
    height: 18
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 12,
    y: 50,
    rx: 3,
    ry: 3,
    width: 70,
    height: 18
  }), canAdmin && /*#__PURE__*/_react.default.createElement("rect", {
    x: 12,
    y: 90,
    rx: 3,
    ry: 3,
    width: 100,
    height: 18
  }));
};
var LifecycleState = function LifecycleState(_ref2) {
  var asset = _ref2.asset,
    status = _ref2.status,
    canEdit = _ref2.canEdit,
    canAdmin = _ref2.canAdmin,
    lifecycleStateActions = _ref2.lifecycleStateActions,
    dependencies = _ref2.dependencies,
    isLoadingAssetStatus = _ref2.isLoadingAssetStatus,
    isLoadingLifecycleState = _ref2.isLoadingLifecycleState,
    isLoadingLifecycleStateActions = _ref2.isLoadingLifecycleStateActions,
    onLifecycleStateChange = _ref2.onLifecycleStateChange,
    onFetchLifecycleStateActions = _ref2.onFetchLifecycleStateActions,
    _ref2$lightTheme = _ref2.lightTheme,
    lightTheme = _ref2$lightTheme === void 0 ? false : _ref2$lightTheme,
    hideIcon = _ref2.hideIcon;
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    openModal = _useModals.openModal,
    closeModal = _useModals.closeModal;
  var groupId = asset.groupId,
    assetId = asset.assetId,
    minorVersion = asset.minorVersion,
    version = asset.version;
  var statusQueryParam = (0, _utils.getQueryParam)(location, 'status')[0];
  var assetRoot = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.asset(state, {
      groupId: groupId,
      assetId: assetId,
      minorVersion: minorVersion,
      status: statusQueryParam !== null && statusQueryParam !== void 0 ? statusQueryParam : status
    });
  });
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var getStyle = function getStyle() {
    return (0, _classnames.default)(styles[status], (0, _defineProperty2.default)({}, styles["".concat(status, "Edit")], canEdit));
  };
  var changeQueryParam = function changeQueryParam(targetState) {
    if (statusQueryParam && groupId === (assetRoot === null || assetRoot === void 0 ? void 0 : assetRoot.groupId) && assetId === (assetRoot === null || assetRoot === void 0 ? void 0 : assetRoot.assetId) && version === (assetRoot === null || assetRoot === void 0 ? void 0 : assetRoot.version)) {
      var params = new URLSearchParams({
        status: targetState
      });
      history.replace({
        search: params.toString()
      });
    }
  };
  var handleLifecycleStateChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(targetState) {
      var source;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            source = hideIcon ? 'table' : 'portal';
            _context.prev = 1;
            _context.next = 4;
            return onLifecycleStateChange(targetState);
          case 4:
            changeQueryParam(targetState);
            trackEvent(_events2.EVENT_TYPES.LS_STATE_CHANGE, {
              origin: status,
              targetState: targetState,
              source: source,
              succeed: true
            });
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            trackEvent(_events2.EVENT_TYPES.LS_STATE_CHANGE_ERROR, {
              targetState: targetState,
              source: source,
              succeed: false,
              error: _context.t0.message
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function handleLifecycleStateChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var changeLifecycleState = function changeLifecycleState(_ref4) {
    var targetState = _ref4.targetState,
      showDisallowedPromoting = _ref4.showDisallowedPromoting;
    if (targetState === _types.AssetStatus.PUBLISHED && status === _types.AssetStatus.DEVELOPMENT) {
      if (showDisallowedPromoting) {
        openModal(_DisallowedPromotionModal.default, {
          dependencies: dependencies
        });
      } else {
        var onConfirm = function onConfirm() {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          handleLifecycleStateChange(_types.AssetStatus.PUBLISHED);
          closeModal();
        };
        openModal(_ConfirmationModal.default, {
          closeModal: closeModal,
          onConfirm: onConfirm
        });
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      handleLifecycleStateChange(targetState);
    }
  };
  var getContent = function getContent() {
    var lifecycleStates = (0, _utils.getLifecycleStates)(status, canEdit, canAdmin, lifecycleStateActions);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.menu
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.menuHeader
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.menuTitle
    }, "Change Lifecycle state"), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: tooltipContent
    }, /*#__PURE__*/_react.default.createElement("a", {
      "data-test-id": "ls-info-link",
      "aria-label": "Information about lifecycle states",
      href: "https://docs.mulesoft.com/exchange/lifecycle",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: function onClick() {
        return trackEvent(_events2.EVENT_TYPES.CLICK_LS_INFO);
      },
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.menuIcon,
      size: "xs"
    }, /*#__PURE__*/_react.default.createElement(InfoIcon, null))))), /*#__PURE__*/_react.default.createElement("hr", null), isLoadingLifecycleStateActions ? /*#__PURE__*/_react.default.createElement(LoadingLifecycleStateOptions, {
      canAdmin: canAdmin
    }) : /*#__PURE__*/_react.default.createElement(_Menu.default, {
      testId: "lifecycle-state-menu",
      className: styles.menuOptions
    }, lifecycleStates.map(function (element) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        disabled: element.disabled,
        onClick: function onClick() {
          return changeLifecycleState(element);
        },
        onKeyDown: eventHandlerUtils.onEnterKey(function () {
          return changeLifecycleState(element);
        }),
        testId: "".concat(element.targetState, "-menu-item"),
        key: element.targetState,
        className: styles.menuItem
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.menuItemLabel
      }, /*#__PURE__*/_react.default.createElement("span", null, element.label), element.showDisallowedPromoting ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "xs",
        className: styles.warningIcon
      }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)) : null));
    })));
  };
  var getRoleId = function getRoleId() {
    var source = hideIcon ? 'table' : 'portal';
    var role = 'viewer';
    if (canAdmin) {
      role = 'admin';
    } else if (canEdit && !canAdmin) {
      role = 'contributor';
    }
    return "lifecycle-state-".concat(source, "-").concat(role);
  };
  var popoverContainer = _react.default.useRef(null);
  if (isLoadingAssetStatus) {
    return /*#__PURE__*/_react.default.createElement(LoadingLifecycleState, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "lifecycle-popover-wrapper",
    "data-role-id": getRoleId(),
    ref: popoverContainer,
    className: (0, _classnames.default)(styles.popoverWrapper, (0, _defineProperty2.default)({}, styles.lightTheme, lightTheme))
  }, canEdit && !isLoadingLifecycleState ? /*#__PURE__*/_react.default.createElement(_Popover.default, {
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    content: getContent(),
    anchorPosition: "bl",
    popupPosition: "tl",
    closeOnClickInside: true,
    onOpen: function onOpen() {
      trackEvent(_events2.EVENT_TYPES.OPEN_LS_DROPDOWN);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      onFetchLifecycleStateActions();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.container, getStyle()),
    "data-test-id": "lifecycle-state"
  }, !hideIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(LifecycleStateIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.lifecycleState,
    "data-test-id": "lifecycle-state-label"
  }, (0, _utils.getStatusLabel)(status)), isLoadingLifecycleState ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "s",
    className: styles.spinner,
    "data-test-id": "lifecycle-content-loading"
  }) : canEdit ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xxs",
    "data-test-id": "lifecycle-state-dropdown-icon",
    className: styles.dropdownIcon
  }, /*#__PURE__*/_react.default.createElement(DropdownIcon, null)) : null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: (0, _classnames.default)(styles.container, getStyle()),
    "data-test-id": "lifecycle-state"
  }, !hideIcon ? _react.default.createElement(_Icon.default, {
    size: "xs",
    className: styles.icon
  }, _react.default.createElement(LifecycleStateIcon, null)) : null, _react.default.createElement("span", {
    className: styles.lifecycleState,
    "data-test-id": "lifecycle-state-label"
  }, (0, _utils.getStatusLabel)(status)), isLoadingLifecycleState ? _react.default.createElement(_Spinner.default, {
    size: "s",
    className: styles.spinner,
    "data-test-id": "lifecycle-content-loading"
  }) : canEdit ? _react.default.createElement(_Icon.default, {
    size: "xxs",
    "data-test-id": "lifecycle-state-dropdown-icon",
    className: styles.dropdownIcon
  }, _react.default.createElement(DropdownIcon, null)) : null)));
};
var _default = exports.default = LifecycleState;
//# sourceMappingURL=LifecycleState.js.map